import { useQuery } from "react-query";
import axios from "infra/http";
import { AreaComumHorario } from "../typings";

function useHorariosAreaComum({
  tenantId,
  id,
  dataInicio,
  dataFim,
  unidadeId,
}: {
  tenantId: string;
  id: string;
  dataInicio?: string;
  dataFim?: string;
  unidadeId?: string;
}) {
  return useQuery(
    `/v1/tenants/${tenantId}/area-comum/${id}/dias-ocupados/${dataInicio}/${dataFim}?unidadeId=${unidadeId}`,
    async () => {
      const { data } = await axios.get<AreaComumHorario[]>(
        `/v1/tenants/${tenantId}/area-comum/${id}/dias-ocupados/${dataInicio}/${dataFim}`,
        {
          params: {
            unidadeId,
          }
        }
      );

      return data;
    },
    {
      enabled: !!dataInicio && !!dataFim && !!tenantId && !!id && !!unidadeId,
    }
  );
}

export default useHorariosAreaComum;
